/* Meridian — © 2026 London Point. All rights reserved. */
/* ============ Meridian theme JS — v2.0 ============ */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const PRM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)').matches : false;
  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });
  const moneyHTML = (cents, sup) => {
    const m = money(cents);
    if (!sup) return m;
    const sep = m.includes('.') ? '.' : ',';
    const parts = m.split(sep);
    if (parts.length === 2 && parts[1].length <= 2) return `${parts[0]}<sup class="price__sup">${parts[1]}</sup>`;
    return m;
  };

  /* ---------- overlay + drawer plumbing ---------- */
  const overlay = () => $('#PageOverlay');
  function openDrawer(el) {
    if (!el) return;
    el.hidden = false;
    requestAnimationFrame(() => el.classList.add('is-open'));
    const o = overlay(); if (o) o.hidden = false;
    document.body.style.overflow = 'hidden';
    el.querySelector('[autofocus],button,a,input')?.focus();
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      setTimeout(() => (d.hidden = true), 300);
    });
    $$('.facets.is-open').forEach((f) => f.classList.remove('is-open'));
    const o = overlay(); if (o) o.hidden = true;
    document.body.style.overflow = '';
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-overlay]') || e.target.closest('[data-drawer-close]')) closeDrawers();
  });
  document.addEventListener('keydown', (e) => e.key === 'Escape' && closeDrawers());

  /* ---------- mobile menu + mega menu ---------- */
  $('[data-menu-toggle]')?.addEventListener('click', () => openDrawer($('#MobileMenu')));
  $$('.nav__item[data-mega]').forEach((item) => {
    let t;
    item.addEventListener('mouseenter', () => { clearTimeout(t); item.setAttribute('open', ''); });
    item.addEventListener('mouseleave', () => { t = setTimeout(() => item.removeAttribute('open'), 120); });
  });

  /* ---------- sticky header shadow ---------- */
  const header = $('.header--sticky');
  if (header) {
    const onScroll = () => header.classList.toggle('is-stuck', window.scrollY > 4);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- cart ---------- */
  async function refreshCart() {
    const res = await fetch('/?section_id=cart-drawer');
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('#CartDrawer .drawer__inner');
    const target = $('#CartDrawer .drawer__inner');
    if (fresh && target) target.replaceWith(fresh);
    updateCartCount();
  }
  async function refreshCartPage() {
    const page = $('[data-cart-page]');
    if (!page) return;
    const res = await fetch(`${window.location.pathname}?section_id=${page.dataset.sectionId}`);
    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.querySelector('[data-cart-page]');
    if (fresh) page.innerHTML = fresh.innerHTML;
    page.classList.remove('loading');
  }
  async function updateCartCount() {
    const c = await (await fetch('/cart.js')).json();
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = c.item_count;
      el.hidden = c.item_count === 0;
    });
  }
  async function addToCart(form, btn) {
    const original = btn?.textContent;
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
      if (!res.ok) throw new Error((await res.json()).description || 'Could not add to cart');
      await refreshCart();
      const qs = $('[data-quick-shop]');
      if (qs?.open) qs.close();
      if (document.body.dataset.cartType !== 'page') openDrawer($('#CartDrawer'));
      else window.location.href = '/cart';
    } catch (err) {
      alert(err.message);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = original; }
    }
  }
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type=submit]'));
  });

  // quick add / quick shop
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.quickAdd;
    if (id === 'multi') {
      if (btn.hasAttribute('data-quick-shop-open')) openQuickShop(btn.dataset.url);
      else window.location.href = btn.dataset.url;
      return;
    }
    const f = document.createElement('form');
    f.innerHTML = `<input name="id" value="${id}"><input type=submit>`;
    addToCart(f, btn);
  });

  // cart line change / remove (delegated)
  async function changeLine(line, qty) {
    $('#CartDrawer .drawer__inner')?.classList.add('loading');
    $('[data-cart-page]')?.classList.add('loading');
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: qty }),
    });
    await refreshCart();
    await refreshCartPage();
  }
  document.addEventListener('click', (e) => {
    const rm = e.target.closest('[data-remove-line]');
    if (rm) { e.preventDefault(); changeLine(rm.dataset.removeLine, 0); return; }
    const q = e.target.closest('[data-qty]');
    if (q) {
      const wrap = q.closest('.qty');
      const input = wrap?.querySelector('input');
      if (!input) return;
      let v = (parseInt(input.value, 10) || 1) + (q.dataset.qty === 'up' ? 1 : -1);
      if (input.dataset.line) {
        if (v < 0) v = 0;
        changeLine(input.dataset.line, v);
      } else {
        if (v < 1) v = 1;
        input.value = v;
      }
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('.qty input');
    if (!input || input.dataset.line) return;
    let v = parseInt(input.value, 10);
    if (!Number.isFinite(v) || v < 1) v = 1;
    input.value = v;
  });
  $$('[data-cart-open]').forEach((b) =>
    b.addEventListener('click', (e) => {
      if (document.body.dataset.cartType === 'page') return;
      e.preventDefault(); openDrawer($('#CartDrawer'));
    })
  );

  // order note: save on change (drawer + page)
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note.value }),
    });
  });

  // terms & conditions gate (drawer + page checkout buttons)
  document.addEventListener('click', (e) => {
    const checkout = e.target.closest('[data-checkout-button]');
    if (!checkout) return;
    const scope = checkout.closest('[data-cart-scope]') || document;
    const terms = scope.querySelector('[data-cart-terms]');
    if (terms && !terms.checked) {
      e.preventDefault();
      terms.focus();
      const msg = scope.querySelector('[data-terms-error]');
      if (msg) msg.hidden = false;
    }
  });
  document.addEventListener('change', (e) => {
    const terms = e.target.closest('[data-cart-terms]');
    if (!terms) return;
    const scope = terms.closest('[data-cart-scope]') || document;
    const msg = scope.querySelector('[data-terms-error]');
    if (msg) msg.hidden = terms.checked;
  });

  /* ---------- predictive search ---------- */
  const searchBtn = $('[data-search-toggle]');
  searchBtn?.addEventListener('click', () => {
    openDrawer($('#SearchDrawer'));
    setTimeout(() => $('#SearchDrawer input[type=search]')?.focus(), 120);
  });
  let searchTimer;
  $('#SearchInput')?.addEventListener('input', (e) => {
    clearTimeout(searchTimer);
    const drawer = e.target.closest('#SearchDrawer');
    const results = $('#SearchResults');
    const top = $('#SearchTop');
    const q = e.target.value.trim();
    if (drawer?.dataset.predictive === 'false') return;
    if (q.length < 2) { results.innerHTML = ''; if (top) top.hidden = false; return; }
    const imgSize = parseInt(drawer?.dataset.imageSize, 10) || 56;
    searchTimer = setTimeout(async () => {
      if (top) top.hidden = true;
      results.innerHTML = `<p class="cart-empty">${drawer?.dataset.labelSearching || 'Searching…'}</p>`;
      const types = drawer?.dataset.searchTypes || 'product';
      const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=${encodeURIComponent(types)}&resources[limit]=6&resources[options][unavailable_products]=last`;
      try {
        const data = await (await fetch(url)).json();
        const r = data.resources.results;
        let html = '';
        let count = 0;
        (r.products || []).forEach((p) => {
          count++;
          html += `<a class="cart-line" href="${p.url}" style="grid-template-columns:${imgSize}px 1fr">
            <img src="${p.featured_image?.url || p.image || ''}" width="${imgSize}" height="${imgSize}" alt="" loading="lazy">
            <div><div class="cart-line__title">${p.title}</div>
            <div class="cart-line__meta">${p.price ? money(p.price) : ''}</div></div></a>`;
        });
        [['collections', drawer?.dataset.labelCollection], ['articles', drawer?.dataset.labelArticle], ['pages', drawer?.dataset.labelPage]].forEach(([kind, label]) => {
          (r[kind] || []).forEach((item) => {
            count++;
            html += `<a class="cart-line" href="${item.url}" style="grid-template-columns:1fr">
              <div><div class="cart-line__title">${item.title}</div>
              <div class="cart-line__meta">${label || kind}</div></div></a>`;
          });
        });
        if (count) {
          html += `<a class="link-arrow" style="margin-top:.75rem" href="/search?q=${encodeURIComponent(q)}">${drawer?.dataset.labelAll || 'See all results'}</a>`;
          results.innerHTML = html;
        } else {
          results.innerHTML = `<p class="cart-empty">${(drawer?.dataset.labelNone || 'No results for “[q]”').replace('[q]', q)}</p>`;
        }
      } catch (err) { results.innerHTML = ''; }
    }, 220);
  });

  /* ---------- product media gallery + lightbox ---------- */
  const lightbox = $('[data-lightbox]');
  let lbItems = [], lbIndex = 0;
  function lbShow(i) {
    if (!lightbox || !lbItems.length) return;
    lbIndex = (i + lbItems.length) % lbItems.length;
    const img = lightbox.querySelector('[data-lightbox-img]');
    img.src = lbItems[lbIndex].src;
    img.alt = lbItems[lbIndex].alt || '';
    lightbox.querySelector('[data-lightbox-count]').textContent = `${lbIndex + 1} / ${lbItems.length}`;
  }
  function openLightbox(items, start) {
    if (!lightbox || !items.length) return;
    lbItems = items;
    lbShow(start || 0);
    if (typeof lightbox.showModal === 'function') lightbox.showModal();
  }
  lightbox?.querySelector('[data-lightbox-close]')?.addEventListener('click', () => lightbox.close());
  lightbox?.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => lbShow(lbIndex - 1));
  lightbox?.querySelector('[data-lightbox-next]')?.addEventListener('click', () => lbShow(lbIndex + 1));
  lightbox?.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') lbShow(lbIndex + 1);
    if (e.key === 'ArrowLeft') lbShow(lbIndex - 1);
  });
  lightbox?.addEventListener('click', (e) => { if (e.target === lightbox) lightbox.close(); });

  function initGallery(gal) {
    if (!gal || gal.dataset.galleryInit) return;
    gal.dataset.galleryInit = '1';
    const main = gal.querySelector('[data-gallery-main]');
    if (!main) return;
    const show = (btn) => {
      const tpl = btn.querySelector('template');
      if (tpl) main.innerHTML = tpl.innerHTML;
      gal.querySelectorAll('[data-thumb]').forEach((b) => b.setAttribute('aria-current', 'false'));
      btn.setAttribute('aria-current', 'true');
      main.querySelector('video[autoplay]')?.play?.().catch(() => {});
    };
    gal.querySelectorAll('[data-thumb]').forEach((btn) => btn.addEventListener('click', () => show(btn)));
    gal.showMedia = (mediaId) => {
      const btn = gal.querySelector(`[data-thumb][data-media-id="${mediaId}"]`);
      if (btn && btn.getAttribute('aria-current') !== 'true') show(btn);
    };
    gal.addEventListener('click', (e) => {
      const z = e.target.closest('[data-gallery-zoom]');
      const imgClick = e.target.closest('[data-gallery-main] img[data-zoom-src]');
      const slideClick = e.target.closest('[data-gallery-track] .gallery__slide img');
      if (slideClick) {
        const thumbs = $$('[data-thumb][data-zoom-src]', gal);
        const items = thumbs.map((b) => ({ src: b.dataset.zoomSrc, alt: b.dataset.alt || '' }));
        if (items.length) {
          const slide = slideClick.closest('.gallery__slide');
          openLightbox(items, Math.min(items.length - 1, parseInt(slide.dataset.slideIndex, 10) || 0));
        }
        return;
      }
      if (!z && !imgClick) return;
      const thumbs = $$('[data-thumb][data-zoom-src]', gal);
      const items = thumbs.map((b) => ({ src: b.dataset.zoomSrc, alt: b.dataset.alt || '' }));
      if (!items.length && imgClick) items.push({ src: imgClick.dataset.zoomSrc, alt: imgClick.alt });
      const current = gal.querySelector('[data-thumb][aria-current="true"]');
      openLightbox(items, Math.max(0, thumbs.indexOf(current)));
    });
  }
  $$('[data-gallery]').forEach(initGallery);

  /* ---------- sticky add-to-cart (product page, small screens) ---------- */
  const stickyBar = $('[data-sticky-atc]');
  let stickyPast = false;
  let stickyDisabled = false;
  function applySticky() {
    if (!stickyBar) return;
    const on = stickyPast && !stickyDisabled;
    stickyBar.classList.toggle('is-visible', on);
    stickyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
  }
  function syncStickyAtc(price, disabled, label) {
    if (!stickyBar) return;
    stickyDisabled = !!disabled;
    const btn = stickyBar.querySelector('[data-sticky-submit]');
    if (btn) { btn.disabled = !!disabled; if (label) btn.textContent = label; }
    const p = stickyBar.querySelector('[data-sticky-price]');
    if (p && price != null) p.textContent = money(price);
    applySticky();
  }
  if (stickyBar && 'IntersectionObserver' in window) {
    const anchor = $('[data-atc-anchor]');
    if (anchor) {
      new IntersectionObserver(([entry]) => {
        stickyPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        applySticky();
      }).observe(anchor);
    }
  }

  /* ---------- variant selection (re-initializable for quick shop) ---------- */
  function initProductForm(form) {
    if (form.dataset.init) return;
    form.dataset.init = '1';
    const container = form.closest('[data-product-container]') || document;
    const data = JSON.parse(form.querySelector('[data-variants]')?.textContent || '[]');
    const idField = form.querySelector('[name=id]');
    const submit = form.querySelector('[type=submit]');
    const priceWrap = container.querySelector('[data-product-price]');
    const sup = document.body.dataset.superscript === 'true';
    const labels = {
      add: form.dataset.labelAdd || 'Add to cart',
      soldOut: form.dataset.labelSoldout || 'Sold out',
      unavailable: form.dataset.labelUnavailable || 'Unavailable',
      savePct: form.dataset.labelSavePercent || 'Save [v]%',
      saveAmt: form.dataset.labelSaveAmount || 'Save [v]',
      low: form.dataset.labelLowStock || 'Only [v] left',
      inStock: form.dataset.labelInStock || 'In stock',
      incoming: form.dataset.labelIncoming || 'Restocking soon',
    };
    function selected() {
      const chosen = [];
      form.querySelectorAll('fieldset[data-option-index]').forEach((fs) => {
        const picked = fs.querySelector('input:checked') || fs.querySelector('select');
        chosen[fs.dataset.optionIndex] = picked ? picked.value : null;
      });
      return chosen;
    }
    function setPrice(match) {
      if (!priceWrap) return;
      const now = priceWrap.querySelector('[data-price]');
      const was = priceWrap.querySelector('[data-compare]');
      const save = priceWrap.querySelector('[data-savings]');
      const unit = priceWrap.querySelector('[data-unit]');
      const onSale = match.cap && match.cap > match.price;
      if (now) { now.innerHTML = moneyHTML(match.price, sup); now.classList.toggle('price__sale', !!onSale); }
      if (was) { was.hidden = !onSale; was.innerHTML = onSale ? moneyHTML(match.cap, sup) : ''; }
      if (save) {
        save.hidden = !onSale;
        if (onSale) {
          const mode = form.dataset.savingsMode || 'percent';
          save.textContent = mode === 'amount'
            ? labels.saveAmt.replace('[v]', money(match.cap - match.price))
            : labels.savePct.replace('[v]', Math.round(((match.cap - match.price) / match.cap) * 100));
        }
      }
      if (unit) {
        unit.hidden = !match.unit;
        if (match.unit) unit.innerHTML = `${moneyHTML(match.unit, sup)}&nbsp;/&nbsp;${match.unit_label || ''}`;
      }
    }
    function setInventory(match) {
      const inv = container.querySelector('[data-inventory]');
      if (!inv) return;
      const threshold = parseInt(inv.dataset.threshold, 10) || 5;
      const text = inv.querySelector('[data-inventory-text]');
      inv.classList.remove('inventory--low', 'inventory--incoming');
      if (!match || !match.available) {
        if (match && match.incoming) { inv.hidden = false; inv.classList.add('inventory--incoming'); text.textContent = labels.incoming; }
        else inv.hidden = true;
        return;
      }
      if (match.managed && match.qty > 0 && match.qty <= threshold) {
        inv.hidden = false;
        inv.classList.add('inventory--low');
        text.textContent = labels.low.replace('[v]', match.qty);
      } else if (inv.dataset.showInstock === 'false') {
        inv.hidden = true;
      } else {
        inv.hidden = false;
        text.textContent = labels.inStock;
      }
    }
    function update() {
      const chosen = selected();
      form.querySelectorAll('fieldset[data-option-index]').forEach((fs) => {
        const label = fs.querySelector('[data-option-selected]');
        if (label) label.textContent = chosen[fs.dataset.optionIndex] || '';
      });
      const match = data.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) {
        submit.disabled = true; submit.textContent = labels.unavailable;
        if (form.dataset.main) syncStickyAtc(null, true, labels.unavailable);
        setInventory(null);
        return;
      }
      idField.value = match.id;
      submit.disabled = !match.available;
      submit.textContent = match.available ? labels.add : labels.soldOut;
      setPrice(match);
      setInventory(match);
      if (match.fmid) container.querySelector('[data-gallery]')?.showMedia?.(match.fmid);
      if (match.fmid) {
        const slide = container.querySelector(`[data-gallery-track] [data-media-id="${match.fmid}"]`);
        const track = container.querySelector('[data-gallery-track]');
        if (slide && track) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: PRM ? 'auto' : 'smooth' });
      }
      if (form.dataset.main) {
        loadPickup(match.id);
        syncStickyAtc(match.price, submit.disabled, submit.textContent);
        history.replaceState({}, '', `?variant=${match.id}`);
      }
    }
    form.addEventListener('change', (e) => { if (e.target.matches('[data-option]')) update(); });
    update();
  }
  $$('[data-product-form]').forEach(initProductForm);

  /* ---------- quick shop ---------- */
  const quickShop = $('[data-quick-shop]');
  async function openQuickShop(url) {
    if (!quickShop || typeof quickShop.showModal !== 'function') { window.location.href = url; return; }
    const content = quickShop.querySelector('[data-quick-shop-content]');
    content.innerHTML = `<p class="quick-shop__loading">${quickShop.dataset.labelLoading || 'Loading…'}</p>`;
    quickShop.showModal();
    try {
      const res = await fetch(`${url.split('?')[0]}?section_id=quick-shop`);
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const inner = doc.querySelector('[data-quick-shop-product]');
      if (!inner) throw new Error('missing');
      content.innerHTML = inner.outerHTML;
      const f = content.querySelector('[data-product-form]');
      if (f) initProductForm(f);
      initGallery(content.querySelector('[data-gallery]'));
    } catch (err) {
      quickShop.close();
      window.location.href = url;
    }
  }
  quickShop?.querySelector('[data-quick-shop-close]')?.addEventListener('click', () => quickShop.close());
  quickShop?.addEventListener('click', (e) => { if (e.target === quickShop) quickShop.close(); });

  /* ---------- collection: facets + sort (AJAX via section rendering) ---------- */
  const facetsRoot = $('[data-collection-root]');
  if (facetsRoot) {
    const sectionId = facetsRoot.dataset.sectionId;
    let controller;
    function collectParams() {
      const form = facetsRoot.querySelector('[data-facets-form]');
      const params = new URLSearchParams(new FormData(form));
      [...new Set(params.keys())].forEach((k) => {
        if (params.getAll(k).every((v) => v === '')) params.delete(k);
      });
      return params;
    }
    async function applyFacets(params, push = true) {
      const qs = params.toString();
      const url = `${window.location.pathname}${qs ? '?' + qs : ''}`;
      facetsRoot.querySelector('[data-collection-results]')?.classList.add('loading');
      controller?.abort();
      controller = new AbortController();
      try {
        const res = await fetch(`${window.location.pathname}?${qs ? qs + '&' : ''}section_id=${sectionId}`, { signal: controller.signal });
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        ['[data-collection-results]', '[data-facets]', '[data-active-facets]', '[data-collection-count]'].forEach((sel) => {
          const fresh = doc.querySelector(sel);
          const target = facetsRoot.querySelector(sel);
          if (fresh && target) target.innerHTML = fresh.innerHTML;
        });
        facetsRoot.querySelector('[data-collection-results]')?.classList.remove('loading');
        initPriceSlider(facetsRoot);
        if (push) history.pushState({ facets: true }, '', url);
      } catch (err) { /* aborted */ }
    }
    facetsRoot.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) {
        const mirror = facetsRoot.querySelector('[data-sort-mirror]');
        if (mirror) { mirror.value = e.target.value; applyFacets(collectParams()); }
        else {
          const u = new URL(location.href);
          u.searchParams.set('sort_by', e.target.value);
          location.href = u.toString();
        }
        return;
      }
      if (e.target.closest('[data-price-slider]')) return;
      if (e.target.closest('[data-facets-form]')) applyFacets(collectParams());
    });
    facetsRoot.addEventListener('submit', (e) => { if (e.target.closest('[data-facets-form]')) e.preventDefault(); });
    facetsRoot.addEventListener('click', (e) => {
      const link = e.target.closest('[data-facet-remove]');
      if (link) { e.preventDefault(); applyFacets(new URL(link.href).searchParams); return; }
      const toggle = e.target.closest('[data-facets-toggle]');
      if (toggle) {
        const panel = facetsRoot.querySelector('[data-facets]');
        panel?.classList.toggle('is-open');
        const o = overlay(); if (o) o.hidden = !panel?.classList.contains('is-open');
      }
    });
    window.addEventListener('popstate', (e) => { if (e.state?.facets) window.location.reload(); });

    function initPriceSlider(root) {
      const slider = root.querySelector('[data-price-slider]');
      if (!slider || slider.dataset.init) return;
      slider.dataset.init = '1';
      const ranges = $$('input[type=range]', slider);
      if (ranges.length < 2) return;
      const [lo, hi] = ranges;
      const fill = slider.querySelector('.price-slider__fill');
      const outLo = slider.querySelector('[data-price-lo]');
      const outHi = slider.querySelector('[data-price-hi]');
      const gteInput = slider.querySelector('[data-price-gte]');
      const lteInput = slider.querySelector('[data-price-lte]');
      const max = parseFloat(lo.max) || 1;
      const draw = () => {
        const a = Math.min(parseFloat(lo.value), parseFloat(hi.value));
        const b = Math.max(parseFloat(lo.value), parseFloat(hi.value));
        if (fill) { fill.style.left = `${(a / max) * 100}%`; fill.style.width = `${((b - a) / max) * 100}%`; }
        if (outLo) outLo.textContent = money(a * 100);
        if (outHi) outHi.textContent = money(b * 100);
        return [a, b];
      };
      ranges.forEach((r) => {
        r.addEventListener('input', draw);
        r.addEventListener('change', () => {
          const [a, b] = draw();
          gteInput.value = a > 0 ? a : '';
          lteInput.value = b < max ? b : '';
          applyFacets(collectParams());
        });
      });
      draw();
    }
    initPriceSlider(facetsRoot);
  }
  // legacy sort hook (used when facets aren't rendered)
  $('[data-sort]')?.addEventListener('change', (e) => {
    if (facetsRoot) return;
    const u = new URL(location.href);
    u.searchParams.set('sort_by', e.target.value);
    location.href = u.toString();
  });

  /* ---------- product card color swatches ---------- */
  document.addEventListener('click', (e) => {
    const sw = e.target.closest('[data-card-swatch]');
    if (!sw) return;
    e.preventDefault();
    const card = sw.closest('.card');
    if (!card) return;
    const img = card.querySelector('.img-main');
    if (img && sw.dataset.image) { img.src = sw.dataset.image; img.srcset = ''; }
    if (sw.dataset.variantUrl) {
      card.querySelectorAll('a.card__media, .card__title a').forEach((a) => (a.href = sw.dataset.variantUrl));
      const qa = card.querySelector('[data-quick-add]');
      if (qa && qa.dataset.url) qa.dataset.url = sw.dataset.variantUrl;
    }
    card.querySelectorAll('[data-card-swatch]').forEach((b) => b.setAttribute('aria-pressed', b === sw ? 'true' : 'false'));
  });

  /* ---------- product recommendations ---------- */
  function loadRecommendations(el) {
    const run = async () => {
      let pid = el.dataset.productId;
      if (!pid) {
        try { pid = (await (await fetch('/cart.js')).json()).items[0]?.product_id; } catch (err) {}
      }
      if (!pid) { el.dataset.recsState = 'empty'; return; }
      try {
        const url = `${el.dataset.url}?section_id=${encodeURIComponent(el.dataset.sectionName)}&product_id=${pid}&limit=${el.dataset.limit || 4}&intent=${el.dataset.intent || 'related'}`;
        const res = await fetch(url);
        if (!res.ok) throw new Error(res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-recommendations-grid]');
        const target = el.querySelector('[data-recommendations-grid]');
        const content = el.querySelector('.recs__content');
        if (fresh && target && content && fresh.children.length) {
          target.innerHTML = fresh.innerHTML;
          content.hidden = false;
          el.dataset.recsState = 'loaded';
        } else {
          el.dataset.recsState = 'empty';
        }
      } catch (err) {
        el.dataset.recsState = 'empty';
      }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { io.disconnect(); run(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else run();
  }
  $$('[data-recommendations][data-recs-state="pending"]').forEach(loadRecommendations);

  /* ---------- recently viewed ---------- */
  const RV_KEY = 'meridian:recent';
  const rvRead = () => { try { return JSON.parse(localStorage.getItem(RV_KEY)) || []; } catch (e) { return []; } };
  const rvHandle = $('[data-product-handle]')?.dataset.productHandle;
  if (rvHandle) {
    try {
      const list = rvRead().filter((h) => h !== rvHandle);
      list.unshift(rvHandle);
      localStorage.setItem(RV_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  $$('[data-recently-viewed]').forEach((el) => {
    const run = async () => {
      const limit = parseInt(el.dataset.limit, 10) || 4;
      const handles = rvRead().filter((h) => h !== rvHandle).slice(0, limit);
      if (!handles.length) { el.dataset.recsState = 'empty'; return; }
      const grid = el.querySelector('[data-recently-viewed-grid]');
      const cards = await Promise.all(handles.map(async (h) => {
        try {
          const res = await fetch(`/products/${h}?section_id=api-card`);
          if (!res.ok) return '';
          const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
          return doc.querySelector('[data-api-card]')?.innerHTML || '';
        } catch (err) { return ''; }
      }));
      const html = cards.filter(Boolean).join('');
      if (html) {
        grid.innerHTML = html;
        el.querySelector('.recs__content').hidden = false;
        el.dataset.recsState = 'loaded';
      } else { el.dataset.recsState = 'empty'; }
    };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (entries.some((en) => en.isIntersecting)) { io.disconnect(); run(); }
      }, { rootMargin: '400px 0px' });
      io.observe(el);
    } else run();
  });

  /* ---------- slideshow (original, dependency-free) ---------- */
  $$('[data-slideshow]').forEach((show) => {
    const track = show.querySelector('[data-slideshow-track]');
    const slides = $$('.slide', track);
    if (!track || slides.length < 2) return;
    const dots = $$('[data-slide-dot]', show);
    let index = 0, timer;
    const go = (i, smooth = true) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * index, behavior: smooth && !PRM ? 'smooth' : 'auto' });
      syncDots();
    };
    const syncDots = () => dots.forEach((d, i) => d.setAttribute('aria-current', i === index ? 'true' : 'false'));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== index) { index = i; syncDots(); }
    }, { passive: true });
    show.querySelector('[data-slide-prev]')?.addEventListener('click', () => { stop(); go(index - 1); });
    show.querySelector('[data-slide-next]')?.addEventListener('click', () => { stop(); go(index + 1); });
    dots.forEach((d, i) => d.addEventListener('click', () => { stop(); go(i); }));
    const speed = parseInt(show.dataset.autoplay, 10) || 0;
    const stop = () => { clearInterval(timer); timer = null; };
    const start = () => { if (speed && !PRM && !timer) timer = setInterval(() => go(index + 1), speed * 1000); };
    show.addEventListener('mouseenter', stop);
    show.addEventListener('mouseleave', start);
    show.addEventListener('focusin', stop);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
    syncDots();
    start();
  });

  /* ---------- rotating announcements ---------- */
  $$('[data-announcements]').forEach((bar) => {
    const msgs = $$('[data-announcement-msg]', bar);
    if (msgs.length < 2) return;
    let i = 0;
    const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    if (PRM) return;
    setInterval(() => {
      msgs[i].hidden = true;
      i = (i + 1) % msgs.length;
      msgs[i].hidden = false;
    }, speed);
  });

  /* ---------- collection tabs (featured collections) ---------- */
  $$('[data-collection-tabs]').forEach((tabs) => {
    const btns = $$('[role=tab]', tabs);
    const panels = $$('[role=tabpanel]', tabs);
    btns.forEach((btn, i) => btn.addEventListener('click', () => {
      btns.forEach((b, j) => b.setAttribute('aria-selected', i === j ? 'true' : 'false'));
      panels.forEach((p, j) => (p.hidden = i !== j));
    }));
  });

  /* ---------- deferred video (featured video / hero) ---------- */
  document.addEventListener('click', (e) => {
    const play = e.target.closest('[data-video-play]');
    if (!play) return;
    const wrap = play.closest('[data-video]');
    const tpl = wrap?.querySelector('template');
    if (!tpl) return;
    wrap.insertAdjacentHTML('beforeend', tpl.innerHTML);
    play.remove();
    wrap.querySelector('video')?.play?.().catch(() => {});
  });

  /* ---------- newsletter popup ---------- */
  const popup = $('[data-popup]');
  if (popup && typeof popup.showModal === 'function') {
    const key = 'meridian:popup';
    const days = parseInt(popup.dataset.frequency, 10) || 14;
    const last = parseInt(localStorage.getItem(key) || '0', 10);
    const due = Date.now() - last > days * 864e5;
    const dismiss = () => { try { localStorage.setItem(key, String(Date.now())); } catch (e) {} };
    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.target.contains(popup)) popup.showModal();
      });
      document.addEventListener('shopify:section:deselect', () => popup.open && popup.close());
    } else if (due && !document.body.classList.contains('template-password')) {
      const delayS = parseInt(popup.dataset.delay, 10);
      setTimeout(() => { if (!$('.drawer.is-open')) popup.showModal(); }, (Number.isFinite(delayS) ? delayS : 5) * 1000);
      popup.addEventListener('close', dismiss);
    }
    popup.querySelector('[data-popup-close]')?.addEventListener('click', () => popup.close());
    popup.addEventListener('click', (e) => { if (e.target === popup) popup.close(); });
  }

  /* ---------- localization selectors ---------- */
  document.addEventListener('change', (e) => {
    const sel = e.target.closest('[data-locale-select], [data-country-select]');
    if (!sel) return;
    const form = sel.closest('form');
    const input = form?.querySelector(`input[name="${sel.dataset.param}"]`);
    if (input) { input.value = sel.value; form.submit(); }
  });

  /* ---------- reveal on scroll (setting + PRM-safe) ---------- */
  if (document.body.hasAttribute('data-animate-reveal') && !PRM && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-revealed'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('#MainContent .section, #MainContent .scheme').forEach((s) => {
      s.classList.add('section-reveal');
      io.observe(s);
    });
  }

  /* ---------- customer accounts: country/province + login views + confirms ---------- */
  function initCountrySelect(sel) {
    const wrap = sel.closest('form')?.querySelector('[data-province-wrap]');
    const prov = wrap?.querySelector('[data-address-province]');
    const apply = () => {
      const opt = sel.options[sel.selectedIndex];
      let provinces = [];
      try { provinces = JSON.parse(opt?.dataset.provinces || '[]'); } catch (e) {}
      if (!prov) return;
      prov.innerHTML = '';
      if (!provinces.length) { wrap.hidden = true; return; }
      wrap.hidden = false;
      provinces.forEach(([val, label]) => {
        const o = document.createElement('option');
        o.value = val; o.textContent = label;
        if (val === prov.dataset.default) o.selected = true;
        prov.appendChild(o);
      });
    };
    if (sel.dataset.default) sel.value = sel.dataset.default;
    sel.addEventListener('change', apply);
    apply();
  }
  $$('[data-address-country]').forEach(initCountrySelect);

  document.addEventListener('click', (e) => {
    const c = e.target.closest('[data-confirm]');
    if (c && !window.confirm(c.dataset.confirm)) e.preventDefault();
    const showRecover = e.target.closest('[data-show-recover]');
    const showLogin = e.target.closest('[data-show-login]');
    if (showRecover || showLogin) {
      e.preventDefault();
      const login = $('[data-login-view]');
      const recover = $('[data-recover-view]');
      if (login && recover) {
        login.hidden = !!showRecover;
        recover.hidden = !showRecover;
        (showRecover ? recover : login).querySelector('input')?.focus();
      }
    }
  });
  if (location.hash === '#recover') {
    const login = $('[data-login-view]');
    const recover = $('[data-recover-view]');
    if (login && recover) { login.hidden = true; recover.hidden = false; }
  }

  /* ---------- product page: thumbnail arrows ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-thumbs-scroll]');
    if (!btn) return;
    const strip = btn.closest('.thumbs-nav')?.querySelector('.gallery__thumbs');
    if (!strip) return;
    const delta = strip.clientWidth * 0.8 * (btn.dataset.thumbsScroll === 'next' ? 1 : -1);
    strip.scrollBy ? strip.scrollBy({ left: delta, behavior: PRM ? 'auto' : 'smooth' }) : (strip.scrollLeft += delta);
  });

  /* ---------- product page: size chart dialog ---------- */
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-size-chart-open]')) {
      const dlg = e.target.closest('[data-product-container]')?.querySelector('[data-size-chart]');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
      return;
    }
    const close = e.target.closest('[data-size-chart-close]');
    if (close) close.closest('[data-size-chart]')?.close();
  });
  $$('[data-size-chart]').forEach((dlg) => {
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
  });

  /* ---------- product page: local pickup availability ---------- */
  async function loadPickup(variantId) {
    const el = $('[data-pickup]');
    if (!el || !variantId) return;
    try {
      const res = await fetch(`/variants/${variantId}?section_id=pickup-availability`);
      if (!res.ok) return;
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-pickup-content]');
      if (fresh) el.innerHTML = fresh.outerHTML;
    } catch (err) { /* leave as is */ }
  }
  {
    const mainForm = $('[data-product-form][data-main]');
    const initialId = mainForm?.querySelector('[name=id]')?.value;
    if ($('[data-pickup]') && initialId) loadPickup(initialId);
  }

  /* ---------- parallax media (collection hero) ---------- */
  if (!PRM) {
    $$('[data-parallax]').forEach((media) => {
      let raf = null;
      const update = () => {
        raf = null;
        const rect = media.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        const progress = rect.top / window.innerHeight;
        media.style.transform = `translateY(${progress * -40}px)`;
      };
      window.addEventListener('scroll', () => { if (!raf) raf = requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  /* ---------- country selector flag emoji ---------- */
  $$('select[data-flags]').forEach((sel) => {
    [...sel.options].forEach((opt) => {
      const iso = (opt.value || '').toUpperCase();
      if (iso.length === 2 && !opt.dataset.flagged) {
        opt.dataset.flagged = '1';
        const flag = String.fromCodePoint(...[...iso].map((c) => 0x1f1e6 + c.charCodeAt(0) - 65));
        opt.textContent = `${flag} ${opt.textContent}`;
      }
    });
  });

  /* ---------- typing placeholder for the header search bar ---------- */
  (() => {
    const input = $('.header-search-bar__input[data-typing]');
    if (!input || PRM) return;
    const phrases = (input.dataset.typing || '').split(/[,|]/).map((p) => p.trim()).filter(Boolean);
    if (!phrases.length) return;
    const base = input.placeholder;
    let pi = 0, ci = 0, erasing = false, timer = null;
    const paused = () => document.activeElement === input || input.value;
    function tick() {
      if (paused()) { input.placeholder = base; timer = setTimeout(tick, 900); return; }
      const phrase = phrases[pi];
      if (!erasing) {
        ci += 1;
        input.placeholder = phrase.slice(0, ci);
        if (ci >= phrase.length) { erasing = true; timer = setTimeout(tick, 1200); return; }
        timer = setTimeout(tick, 75);
      } else {
        ci -= 1;
        input.placeholder = phrase.slice(0, ci);
        if (ci <= 0) { erasing = false; pi = (pi + 1) % phrases.length; timer = setTimeout(tick, 350); return; }
        timer = setTimeout(tick, 40);
      }
    }
    timer = setTimeout(tick, 1400);
    document.addEventListener('visibilitychange', () => {
      clearTimeout(timer);
      if (!document.hidden) timer = setTimeout(tick, 800);
    });
  })();

  /* ---------- reveal on scroll ---------- */
  (() => {
    if (PRM || !document.body.hasAttribute('data-reveal') || !('IntersectionObserver' in window)) return;
    const targets = $$('.card, .promo-cell, .custom-content__cell, .section-head, .iwt, .testimonial, .text-col');
    if (!targets.length) return;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('rv-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    targets.forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return; // above the fold: show instantly
      const sibs = el.parentElement ? [...el.parentElement.children] : [el];
      el.style.setProperty('--rv-d', `${(sibs.indexOf(el) % 6) * 70}ms`);
      el.classList.add('rv');
      io.observe(el);
    });
  })();

  /* ---------- product row carousels (arrows + progress, delegation-proof) ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-car-prev], [data-car-next]');
    if (!btn) return;
    const track = btn.closest('[data-carousel]')?.querySelector('[data-car-track]');
    if (!track) return;
    const step = track.clientWidth * 0.92 * (btn.hasAttribute('data-car-next') ? 1 : -1);
    track.scrollBy({ left: step, behavior: PRM ? 'auto' : 'smooth' });
  });
  document.addEventListener('scroll', (e) => {
    const t = e.target;
    if (!(t instanceof Element) || !t.hasAttribute || !t.hasAttribute('data-car-track')) return;
    const bar = t.closest('[data-carousel]')?.querySelector('[data-car-progress]');
    if (!bar) return;
    const max = t.scrollWidth - t.clientWidth;
    bar.style.width = max > 0 ? `${Math.max(8, Math.min(100, ((t.scrollLeft + t.clientWidth) / t.scrollWidth) * 100))}%` : '100%';
  }, true);

  updateCartCount();
})();
